import { Outlet, createRootRoute, useRouterState } from '@tanstack/react-router';

import { AppShell } from '../app/shell';
import { ActivityStreamProvider } from '../app/stream-provider';
import { AuthGuard } from '../features/auth/guard';
import { CaptureSurface } from '../features/quick-add/CaptureSurface';

/**
 * الجذر (§1.2): AppShell يغلّف كل الشاشات. الاستثناء الوحيد `/login` — لا تنقل
 * ولا شريط سفلي قبل المصادقة (قرار D55)، فالشاشة تُعرض عارية ممركزة.
 *
 * `CaptureSurface` يغلّف القشرة نفسها (§6.4): لوحة الالتقاط تُفتح فوق أي شاشة،
 * وطبقة الـ toast وحبر الالتقاط تعيشان أعلى الشجرة كي تنجو من إغلاق اللوحة.
 * لا سطح التقاط على `/login` — لا كتابة قبل المصادقة.
 *
 * و`AuthGuard` يغلّف القشرة: الخادم يرفض كل نقطة بـ 401 بلا جلسة فلا تتسرب بيانة،
 * لكن رسم الشريط الجانبي و«صباح النور» لزائر بلا جلسة **يكذب عليه** — فيُوجَّه إلى
 * `/login` بدل أن يقابله صف رسائل خطأ لا يفهم سببها.
 *
 * و`ActivityStreamProvider` **داخل** الحارس لا خارجه: البثّ يصادَق بكوكي الجلسة
 * (قرار D47)، فاتصالٌ يُفتح قبل الدخول يُقابَل بـ401 ويُغلقه المتصفح نهائيًا — أي
 * شارة «متوقف» على أول شاشة يراها المالك بعد الدخول. وهو يغلّف كل الشاشات لأن
 * الحيوية ليست شأن شاشة النشاط وحدها (§1.3) — راجع سبب وجوده في `stream-provider.tsx`.
 */
export const Route = createRootRoute({ component: RootLayout });

function RootLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  if (pathname === '/login' || pathname.startsWith('/login/')) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-bg px-4 text-text">
        <div className="w-full max-w-96">
          <Outlet />
        </div>
      </div>
    );
  }

  return (
    <AuthGuard>
      <ActivityStreamProvider>
        <CaptureSurface>
          <AppShell>
            <Outlet />
          </AppShell>
        </CaptureSurface>
      </ActivityStreamProvider>
    </AuthGuard>
  );
}
